import { Component, OnInit,Input, EventEmitter, Output } from '@angular/core';
import { KmsService } from 'src/app/areas/kms/kms.service';
import { SwMaskService } from 'src/app/librarys/components/basic-components/sw-mask/sw-mask.service';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';

@Component({
  selector: 'app-concept-addorupdate',
  templateUrl: './concept-addorupdate.component.html',
  styleUrls: ['./concept-addorupdate.component.css']
})
export class ConceptAddorupdateComponent implements OnInit {
  //接收父组件的数据  
  @Input() addOrUpdate:string;              // 操作类型
  @Input() id:string;              // 概念主键id（自增长id）
  @Input() modelVerId:string;              // 模型版本id
  // 新增或编辑操作成功后向父组件发射数据
  @Output('conceptSave') conceptSave = new EventEmitter<any>();  
  // 取消操作成功后向父组件发射数据
  @Output('conceptCancel') conceptCancel = new EventEmitter<any>();  

  formModel:any = {}; // 表单信息
  ontologyTreeDatas:any = [];  // 概念树数据
  rootNode:any = {};  // 根节点信息
  readonlySelfIds:any = [];  // 不可选择的父级节点
  selectParentData: any;   // 父级分类下拉选中数据
  onlyEditName:boolean = true;

  constructor(
    private kmsService: KmsService,
    private message: SwMassageBoxService,
    private swMaskService: SwMaskService
  ) { }

  ngOnInit() {
  }

  ngOnChanges() {
    this.onlyEditName = true;
    this.getOnlogyTreePageList();
    if(this.addOrUpdate == 'editConcept'){
      // 编辑时，不可选择父级节点为本身
      this.readonlySelfIds = [this.id];
      // 根据主键查询概念信息
      this.kmsService.getConceptById(this.id).subscribe(
        result => {
            if (result.code == 200) {
                this.formModel = result.data;
                this.formModel.pid = result.data.parentId;
                if(result.data.parentId == 'root'){
                  this.selectParentData = JSON.parse(JSON.stringify(this.rootNode));
                  this.formModel.pid = this.rootNode.id;
                }
            }
        }
      )
    }else{
      this.readonlySelfIds = [];
      this.selectParentData = null;
      this.formModel = {};
      this.formModel.conceptLevel = 1;
    }
  }

  // 请求概念数据模型方法
  getOnlogyTreePageList() {
    this.ontologyTreeDatas = [];
    this.kmsService.getConceptTree(this.modelVerId).subscribe(
        result => {
            if (result.code == 200) {
                if (!result.data) {
                    this.ontologyTreeDatas = [];
                    return;
                }
                let datas = result.data;
                this.ontologyTreeDatas = datas;
                this.rootNode = datas.length>0 ? datas[0] : {};
            } else {
                this.message.waring(result.msg);
            }
        }
    )
  }

  // 父级分类下拉点击方法
  handleConceptChange(event) {
    let items = this.ontologyTreeDatas.filter(item => item.id == event.id)[0];
    this.selectParentData = items;
  }

  // 表单提交方法
  onSubmit() {
    this.swMaskService.openMask("数据正在保存,请稍等...");
    // 判断是否为重命名操作
    if(this.addOrUpdate == 'editConcept' && this.onlyEditName){
      let params = {
        id:this.formModel.id,
        conceptName: this.formModel.conceptName,
      }
      this.kmsService.updateConceptName(params).subscribe(
          result => {
              this.swMaskService.closeMask();
              if (result.code == 200) {
                this.message.success('操作成功！');
                // 当前为重命名操作才发射true,父元素接收到后将不会刷新模型树，只更新模型可视化组件
                this.conceptSave.emit(true);
              } else {
                this.message.waring(result.msg);
              }
          }
      )
    }
    // 新增、编辑概念操作
    else{
      let parentId = '', parentCode = '';
      if (this.selectParentData) {
          if (this.rootNode  && this.selectParentData.id === this.rootNode.id) {
              parentId = 'root';
              parentCode = '',
              this.formModel.conceptLevel = 1;
          } else {
              parentId = this.selectParentData.id;
              parentCode = this.selectParentData.code;
              this.formModel.conceptLevel = this.selectParentData.level + 1;
          }
      } else {
        parentId = this.formModel.pid;
        parentCode = this.formModel.parentCode;
      }
      let params = {
          id:this.formModel.id,
          conceptId: this.formModel.conceptId,
          conceptCode: this.formModel.conceptCode,
          conceptName: this.formModel.conceptName,
          conceptLevel: this.formModel.conceptLevel,
          parentId: parentId,
          parentCode: parentCode,
          modelVerId: this.modelVerId,
          sortNum: this.formModel.sortNum
      }
      this.kmsService.saveConceptUpdate(params).subscribe(
          result => {
              this.swMaskService.closeMask();
              if (result.code == 200) {
                this.message.success('操作成功！');
                this.conceptSave.emit(false);
              } else {
                this.message.waring(result.msg);
              }
          }
      )
    }
  }

  // 取消新增或编辑操作
  cancel(){
    this.conceptCancel.emit(true);
  }
}
